import GlobalConfig from "@/core/config/GlobalConfig";

export function getDefaultLanguageData() {
  let defaultLanguageData = {};
  defaultLanguageData = Object.values(GlobalConfig.siteLanguages).filter(data => data.is_default == 1)[0];
  return {
    defaultLanguageData
  };
}